import React from 'react';
import CardDetail from '../../../components/CardDetail';
import { SideAd } from '../../../components/ads';
import ProPageRenderer from '../../../components/ProPageRenderer';
import { SEO } from '../../../components/seo';
import { useUserStore } from '../../../hooks/useUser';

export default function MtgCardDetails({ card }) {
  const { isProMemberActive } = useUserStore();

  const title = card ? `${card.name} | Magic: The Gathering | TCG Stacked` : 'MTG Card Details | TCG Stacked';
  const description = card ? `View details for ${card.name} from ${card.set_name}. ${card.oracle_text?.slice(0, 100)}...` : 'View Magic: The Gathering card details and information';

  return (
    <article>
      <SEO title={title} description={description} fullImageUrl={card?.image_uris?.art_crop || undefined} />

      <ProPageRenderer>
        {/* {isProMemberActive === false && (
          <div className='mb-6 bg-gray-200 dark:bg-gray-800'>
            <BannerAd />
          </div>
        )} */}

        <div className='lg:px-6 pt-6 w-full lg:pt-12 pb-32 flex gap-5 flex-col lg:flex-row'>
          {!isProMemberActive && (
            <div>
              <SideAd />
            </div>
          )}

          <CardDetail card={card} showBuyButton={true} />

          {!isProMemberActive && (
            <div>
              <SideAd />
            </div>
          )}
        </div>
      </ProPageRenderer>
    </article>
  );
}

export async function getServerSideProps({ params }) {
  try {
    const response = await fetch(`https://api.scryfall.com/cards/${params.id}`);

    if (!response.ok) {
      return {
        notFound: true,
      };
    }

    const card = await response.json();

    return {
      props: {
        card,
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}
